import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import {
  setMTracAccount,
  getThirdPartyAccounts,
  updateThirdPartyAccount,
  addNewThirdPartyAccount,
} from '../../../actions/thirdParty'
import { getShopList } from '../../../actions/shop'
import { connect } from 'react-redux'
import { globalValidator } from '../../../utils/validations/common'
import { hasAccess } from '../../../utils/api'
import { openErrorMessage } from '../../../actions/message'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import MTracItem from '../../../components/MTrac/MTracItem'

const MTracItemEditable = EditableHOCWrapper(MTracItem)

class MTrac extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      mtrac: {},
      lastModified: null,
    }
  }

  componentDidMount() {
    this.props.dispatch(getShopList())
    //this.props.dispatch(getThirdPartyAccounts());
    this.fetchMTracAccounts()
  }

  fetchMTracAccounts = () => {
    const data = {}

    this.props.dispatch(getThirdPartyAccounts()).then((thirdPartyAccounts) => {
      const { values = [] } = thirdPartyAccounts || {}
      values &&
        values.length &&
        values.forEach((item) => {
          if (item.accountType === 'Mtrac')
            data[item.shopId] = { ...(data[item.shopId] || {}), ...item }
        })

      this.setState({
        mtrac: data,
        lastModified: new Date().valueOf(),
      })
      this.props.dispatch(setMTracAccount(data))
    })
  }

  onSave = (shopId) => (data, afterSave) => {
    const keys = [
      { name: 'name', title: 'Name', validateKey: 'required' },
      { name: 'username', title: 'Username', validateKey: 'required' },
      { name: 'clientId', title: 'Client Id', validateKey: 'required' },
      { name: 'clientSecret', title: 'Client Secret', validateKey: 'required' },
    ]

    const valid = globalValidator(data, keys)

    if (valid === true) {
      if (data.id) {
        this.props.dispatch(updateThirdPartyAccount(data)).then((res) => {
          this.fetchMTracAccounts()
          afterSave && afterSave()
        })
      } else {
        this.props.dispatch(addNewThirdPartyAccount(data)).then((res) => {
          this.fetchMTracAccounts()
          afterSave && afterSave()
        })
      }
    } else {
      this.props.dispatch(openErrorMessage(valid))
    }
  }

  onCancel = () => {
    const { mtracAccounts = {} } = this.props.thirdPartyReducer
    this.setState({
      mtrac: mtracAccounts,
      editMode: false,
    })
  }

  render() {
    const { mtrac = {}, lastModified } = this.state
    const { shopsList = {} } = this.props.shopReducer

    return (
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll cell-padd-remove">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop</TableCell>
                    <TableCell>Enabled</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Username</TableCell>
                    <TableCell>Client Id</TableCell>
                    <TableCell>Client Secret</TableCell>
                    <TableCell>Location Id</TableCell>
                    {hasAccess() ? <TableCell>Actions</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {shopsList &&
                    shopsList.values &&
                    shopsList.values.length &&
                    shopsList.values.map((shop, index) => {
                      return (
                        <MTracItemEditable
                          key={index}
                          shop={shop}
                          onSave={this.onSave(shop.id)}
                          dataToEdit={mtrac[shop.id] || { shopId: shop.id, accountType: 'Mtrac' }}
                          lastModified={lastModified}
                        />
                      )
                    })}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

const MTracWithTitle = ContainerWithTitleWrapper(MTrac, 'MTrac Settings')

export default connect((state) => {
  return {
    dispatch: state.dispatch,
    thirdPartyReducer: state.thirdPartyReducer,
    shopReducer: state.shopReducer,
  }
})(MTracWithTitle)



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/MTrac.js